import { render, staticRenderFns } from "./CFRubricPrintModal.vue?vue&type=template&id=6896676d&scoped=true"
import script from "./CFRubricPrintModal.vue?vue&type=script&lang=js"
export * from "./CFRubricPrintModal.vue?vue&type=script&lang=js"
import style0 from "./CFRubricPrintModal.vue?vue&type=style&index=0&id=6896676d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896676d",
  null
  
)

export default component.exports